module.exports = __webpack_public_path__ + "img/program-talk_2.959eadae.jpg";